
const rm = (window as any)["rm"] as JSSDKAPI;

const isInIthomeApp = rm.getEnv().app === "ithome";
const isInOtherApp = rm.getEnv().app !== "unknown" && !isInIthomeApp;

// 授权绑定IT之家账号信息缓存
let userInfoCache: { success: boolean, userInfo: any } = { success: false, userInfo: null };
let userHashCache: { success: boolean, userHash: any } = { success: false, userHash: null };

const defaultClostWindow = rm.closeWindow;
rm.closeWindow = () => {
    if (rm.isLegalEnv()) {
        defaultClostWindow()
    } else {
        window.close();
    }
}

const defaultLogin = rm.login;
rm.login = (cb) => {
    if (isInOtherApp) {
        checkAuthLogin(false, () => {
            cb(userInfoCache)
        })
    } else {
        defaultLogin(cb)
    }
}

const defaultGetUserInfo = rm.getUserInfo;
rm.getUserInfo = (cb) => {
    if (isInOtherApp) {
        checkAuthLogin(true, () => {
            cb(userInfoCache)
        })
    } else {
        defaultGetUserInfo(cb)
    }
}

const defaultGetUserInfoSync = rm.getUserInfoSync;
rm.getUserInfoSync = () => {
    if (isInOtherApp) {
        return userInfoCache
    } else {
        return defaultGetUserInfoSync();
    }
}

const defaultGetUserHash = rm.getUserHash;
rm.getUserHash = (cb) => {
    if (isInOtherApp) {
        cb(userHashCache)
    } else {
        defaultGetUserHash(cb)
    }
}

const defaultGetUserHashSync = rm.getUserHashSync;
rm.getUserHashSync = () => {
    if (isInOtherApp) {
        return userHashCache
    } else {
        return defaultGetUserHashSync();
    }
}

const defaultReady = rm.ready;
rm.ready = (cb) => {
    defaultReady(() => {
        if (isInOtherApp) {
            checkAuthLogin(true, () => {
                cb();
            })
        } else {
            cb();
        }
    })
}

/**
 * 支持使用金币商城的客户端
 * @returns 
 */
rm.isSupportMallClient = () => {
    return ["ithome", "zuihuimai"].indexOf(rm.getEnv().app) !== -1;
}

function checkAuthLogin(onlyCheck: boolean, cb: () => void) {
    rm.canIUse(["requestBindAccount"], (res) => {
        if (res.success) {
            rm.requestBindAccount({
                requestBindTo: "ithome",
                onlyCheck,
                dialogTitle: "关联「{appName}」开始使用金币商城"
            }, (bindRes) => {
                if (bindRes.success) {
                    userInfoCache = { success: bindRes.success, userInfo: bindRes.bindUserInfo?.userInfo };
                    userHashCache = { success: bindRes.success, userHash: bindRes.bindUserInfo?.token };
                    rm.request({
                        url: "https://napi.ithome.com/api/user/getuserinfo",
                        method: "get",
                        header: {
                            "userhash": bindRes.bindUserInfo?.token || ''
                        }
                    }, function (response) {
                        userInfoCache = {
                            success: bindRes.success,
                            userInfo: Object.assign(
                                {},
                                response.data.data,
                                bindRes.bindUserInfo?.userInfo,
                            )
                        };
                        cb();
                    })
                } else {
                    cb();
                }
            })
        } else {
            cb();
        }
    })
}


export default rm;